import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'התפריט',
    href: '#menu'
  }, {
    name: 'הסיפור',
    href: '#story'
  }, {
    name: 'גלריה',
    href: '#gallery'
  }, {
    name: 'אירועים',
    href: '#events'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-espresso/95 backdrop-blur-md py-4 shadow-lg shadow-black/20' : 'bg-transparent py-6'}`} dir="rtl" data-id="element-92">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-93">
        <a href="#" className="font-serif text-3xl md:text-4xl text-cream tracking-wider font-medium" data-id="element-94">
          לוּנה
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-95">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-cream/80 hover:text-gold transition-colors text-sm uppercase tracking-widest font-sans" data-id="element-96">
              {link.name}
            </a>)}
          <a href="#reservation" className="border border-gold text-gold px-6 py-2 rounded-none hover:bg-gold hover:text-espresso transition-all duration-300 font-sans text-sm uppercase tracking-widest" data-id="element-97">
            הזמנת שולחן
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden text-cream" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-98">
          {mobileMenuOpen ? <X size={28} data-id="element-99" /> : <Menu size={28} data-id="element-100" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-101">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-espresso border-t border-white/10 shadow-2xl md:hidden" data-id="element-102">
            <div className="flex flex-col p-6 gap-6" data-id="element-103">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-cream text-lg font-serif text-center" data-id="element-104">
                  {link.name}
                </a>)}
              <a href="#reservation" onClick={() => setMobileMenuOpen(false)} className="border border-gold text-gold px-6 py-3 text-center hover:bg-gold hover:text-espresso transition-all font-sans text-sm uppercase tracking-widest mt-4" data-id="element-105">
                הזמנת שולחן
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}